import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../common/CCUtils"
import { COLOR } from "../../../common/Color"
import { TransitionState } from "../../GameState"
import { Buttons } from "../../generic-sprites/Buttons"
import { ColorUtils } from "../../utils/ColorUtils"
import { PhaserUtils } from "../../utils/PhaserUtils"
import { Scale } from "../../utils/Scale"
import {
    TestimonialOutroInfo,
    Testimonials,
    VideoInfo,
} from "../../utils/TestimonialOutro"
import { Videos } from "../../utils/Videos"
import { KidsChoiceAssets } from "./KidsChoiceAssets"

export class KidsChoiceExit extends Phaser.State {
    constructor(
        private videoKey?: string,
        private testimonialIntroAudio?: string,
    ) {
        super()
    }

    preload() {
        const load = PhaserUtils.makeLoader(
            this.game,
            "kids-choice/transitions/testimonials",
        )

        this.testimonialIntroAudio =
            CCUtils.genderifyFileName(`testimonials.mp3`)
        load.audio(
            KidsChoiceAssets.BUDDY_TESTIMONIALS_INTRO,
            this.testimonialIntroAudio,
        )

        load.image(KidsChoiceAssets.TESTIMONIAL_1_IMAGE, "testimonial-1.png")
        load.image(KidsChoiceAssets.TESTIMONIAL_2_IMAGE, "testimonial-2.png")

        load.video(KidsChoiceAssets.TESTIMONIAL_1, "testimonial-1.mp4")
        load.video(KidsChoiceAssets.TESTIMONIAL_2, "testimonial-2.mp4")

        const videoLocation = CCUtils.asset(
            CCUtils.genderifyFileName(`kids-choice/transitions/outro.mp4`),
        )
        this.videoKey = KidsChoiceAssets.OUTRO1
        this.game.load.video(this.videoKey, videoLocation)
    }

    async create() {
        await PhaserUtils.sharedCreateFunctions(this.game)
        ColorUtils.setBackgroundColor(this.game, COLOR.black)

        const outroInfo = new TestimonialOutroInfo()

        outroInfo.testimonialIntroAudio =
            KidsChoiceAssets.BUDDY_TESTIMONIALS_INTRO
        outroInfo.testimonials = [
            new VideoInfo(
                KidsChoiceAssets.TESTIMONIAL_1_IMAGE,
                KidsChoiceAssets.TESTIMONIAL_1,
            ),
            new VideoInfo(
                KidsChoiceAssets.TESTIMONIAL_2_IMAGE,
                KidsChoiceAssets.TESTIMONIAL_2,
            ),
        ]
        outroInfo.goTo = TransitionState.KIDS_CHOICE_EXIT2

        const videoGroup = this.game.add.group()
        await Videos.add(this.game, this.videoKey, {
            onComplete: () => {
                Buttons.create(
                    this.game,
                    "Next",
                    () => {
                        videoGroup.destroy()
                        Testimonials.showTestimonials(
                            this.game,
                            outroInfo,
                            "Before we move on to the next activity, let’s hear from some kids who can tell us what it’s like to experience " +
                                "the health effects of tobacco. Click on any of the pictures to hear what each of these kids has to say.",
                        )
                    },
                    {
                        x: Scale.x(0.84),
                        y: Scale.y(0.9),
                        group: videoGroup,
                    },
                )
            },
            group: videoGroup,
            fillScreen: true,
        })
    }
}
